import { render, staticRenderFns } from "./AddCallQueueModal.vue?vue&type=template&id=e48e15c8&"
import script from "./AddCallQueueModal.vue?vue&type=script&lang=js&"
export * from "./AddCallQueueModal.vue?vue&type=script&lang=js&"
import style0 from "./AddCallQueueModal.vue?vue&type=style&index=0&id=e48e15c8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports